import { render, staticRenderFns } from "./OrganizationStructure.vue?vue&type=template&id=23d02d64"
import script from "./OrganizationStructure.vue?vue&type=script&lang=js"
export * from "./OrganizationStructure.vue?vue&type=script&lang=js"
import style0 from "./OrganizationStructure.vue?vue&type=style&index=0&id=23d02d64&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports